'use strict';

var styled = require('styled-components');
var index = require('../Flex/index.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const SettingsContainer = styled__default.default.div `
  position: relative;
  display: inline-flex;
  justify-content: flex-end;
`;
const SettingsPopinContainer = styled__default.default.div `
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  width: 300px;
  background-color: ${({ theme }) => theme.colors.body.background};
  padding: ${({ theme }) => theme.space.component.x.l};
  border: 1px solid ${({ theme }) => theme.colors.border};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  box-shadow: ${({ theme }) => theme.shadows.default};
  border-radius: ${({ theme }) => theme.radiuses.m};
  z-index: 9;
`;
const FlexDiv = styled__default.default.div `
  display: flex;
  align-items: center;
  margin-top: 0.625rem;
`;
const SettingsDiv = styled__default.default.div `
  margin: 0 0 1rem;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;
const RowStyled = styled__default.default(index.Flex.Row) `
  margin-top: 1.25rem;
`;
const LabelStyled = styled__default.default.label `
  margin-left: 1rem;
`;

exports.FlexDiv = FlexDiv;
exports.LabelStyled = LabelStyled;
exports.RowStyled = RowStyled;
exports.SettingsContainer = SettingsContainer;
exports.SettingsDiv = SettingsDiv;
exports.SettingsPopinContainer = SettingsPopinContainer;
//# sourceMappingURL=useHidableCols.styles.js.map
